module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/_add-to-unscopables.js
// module id = 1086
// module chunks = 0